import { Component, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageService } from 'src/app/services/account/language.service';
import { StackedModalsService } from 'src/app/services/modal/stacked-modals.service';
import { PrivacyPolicyComponent } from 'src/app/components/modals/info/privacy-policy/privacy-policy.component';

/**
 * Asks for consent to Google Analytics. Accept and Reject have the same styling: refusing must
 * be as easy as accepting (docs/cookie-consent.md). The choice can be changed later in the settings dialog.
 */
@Component({
  standalone: true,
  selector: 'app-cookie-panel',
  templateUrl: './cookie-panel.component.html',
  styleUrls: ['./cookie-panel.component.scss'],
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CookiePanelComponent {
  /** True: analytics accepted; false: rejected. */
  @Output() choice = new EventEmitter<boolean>();

  constructor(
    public languageService: LanguageService,
    private readonly stackedModalsService: StackedModalsService
  ) {}

  openPrivacyPolicy(): void {
    this.stackedModalsService.openModal(PrivacyPolicyComponent, {
      panelClass: 'dialog-snap-to-fullscreen',
      autoFocus: false
    });
  }

  accept(): void {
    this.choice.emit(true);
  }

  reject(): void {
    this.choice.emit(false);
  }
}
